import { isBuilderStudyToken } from "../exports/permissions";

export default [
  // 뒤에 path가
  {
    path: "",
    name: "SubjectRedirect",
    component: () => import("../form/resultEntry/Subject.vue"),
    meta: {
      // title: 'U2EDC-Subject',
      title: (to) => {
        const raw = to.query.StudyName ?? "";

        const safe = String(raw).replace(/<[^>]*>?/gm, ""); // 간단 XSS 방지
        return safe ? `${safe} · Subejct` : "Subejct";
      },
      requiresAuth: true,
    },
  },
  {
    path: "/subject/screening",
    beforeEnter: (to, from, next) => {
      // ✅ `requiredKey`가 없는 경우 `/`로 리다이렉트
      if (!to.query.studyId) {
        next("/");
      } else {
        next(); // ✅ 정상 이동
      }
    },
    component: () => import("../form/resultEntry/Screening.vue"),
    meta: { title: "U2EDC-Subject", requiresAuth: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: ":studyId",
    name: "SubjectList",
    component: () => import("../form/resultEntry/Subject.vue"),
    meta: { title: "U2EDC-Subject", requiresAuth: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "query",
    name: "StudyQuery",
    component: () => import("../form/user/Query.vue"),
    meta: { title: "U2EDC-ResultEnty", requiresAuth: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "screening/:studyId",
    name: "Screening",
    component: () => import("../form/resultEntry/Screening.vue"),
    meta: { title: "U2EDC-ResultEnty", requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if (!to.params.studyId) {
        next("/"); // 🔄 studyId가 없으면 메인 페이지로 이동
      } else {
        next(); // ✅ 정상적으로 이동
      }
    },
    props: (route) => ({
      studyId: route.params.studyId,
      StudyShortName: route.params.StudyShortName, // `id`는 URL에서 사용됨
    }),
  },

  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "visit/:studyId",
    name: "Visit",
    component: () => import("../form/resultEntry/Visit.vue"),
    meta: { title: "U2EDC-ResultEnty", requiresAuth: true },
    beforeEnter: (to, from, next) => {
      if (!to.params.studyId) {
        next("/"); // 🔄 studyId가 없으면 메인 페이지로 이동
      } else {
        next(); // ✅ 정상적으로 이동
      }
    },
    props: (route) => ({
      studyId: route.params.studyId,
      StudyShortName: route.params.StudyShortName, // `id`는 URL에서 사용됨
    }),
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "testSpecimenRef",
    name: "SubjectTestSpecimenRef",
    component: () => import("../form/resultEntry/TestSpecimenRef.vue"),
    meta: { title: "U2EDC-ResultEnty", requiresAuth: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "autoQuerySettings",
    name: "AutoQuerySettings",
    component: () => import("../form/resultEntry/TestAutoQuerySettings.vue"),
    meta: { title: "U2EDC-ResultEnty", requiresAuth: true },
  },
  {
    // 통계 데이터 추출 (빌더 연구 · CRA/PI). 권한 판정은 서버(/API/studyExport)가 한다.
    // 1단계는 빌더 연구 한정 — 주소를 직접 쳐서 들어와도 빌더 연구가 아니면 연구 공지사항으로 돌려보낸다.
    path: "statistics",
    name: "SubjectStatistics",
    beforeEnter: (to, from, next) => {
      const token = to.query.token;
      if (!isBuilderStudyToken(token)) {
        next(token ? { path: "/subject/notice", query: { token } } : "/");
        return;
      }
      next();
    },
    component: () => import("../form/resultEntry/StudyStatisticsView.vue"),
    meta: { title: "U2EDC-Statistics", requiresAuth: true },
  },
  // =============================================
  // 연구 별 공지사항 게시판 — 모두 StudyBoard.vue 가 owner.
  // StudyBoard 가 route.name 으로 mode(list/detail/compose) 분기하여
  // BoardList / BoardDetail / BoardCompose 중 하나를 렌더링하고,
  // 저장·삭제·파일 다운로드 같은 API 호출을 모두 수행.
  // =============================================
  {
    path: "notice",
    name: "SubjectNoticeList",
    component: () => import("../form/resultEntry/StudyBoard.vue"),
    meta: { title: "U2EDC-StudyNotice", requiresAuth: true },
  },
  {
    // /new 는 :boardId 보다 먼저 매칭되어야 함
    path: "notice/new",
    name: "SubjectNoticeCompose",
    component: () => import("../form/resultEntry/StudyBoard.vue"),
    meta: { title: "U2EDC-StudyNotice-Compose", requiresAuth: true },
  },
  {
    path: "notice/:boardId/edit",
    name: "SubjectNoticeEdit",
    component: () => import("../form/resultEntry/StudyBoard.vue"),
    props: (route) => ({ boardId: route.params.boardId }),
    meta: { title: "U2EDC-StudyNotice-Edit", requiresAuth: true },
  },
  {
    path: "notice/:boardId",
    name: "SubjectNoticeDetail",
    component: () => import("../form/resultEntry/StudyBoard.vue"),
    props: (route) => ({ boardId: route.params.boardId }),
    meta: { title: "U2EDC-StudyNotice-Detail", requiresAuth: true },
  },
];
